export default __webpack_public_path__ + "static/media/img_post2_3.695771b9.png";